import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {
    color: '#1C2541',
  },
  headerItem: {
    display: 'flex',
    alignItems: 'center',
  },
  headerIcon: {
    marginRight: '8px',
  },
  item: {
    cursor: 'pointer',
  },
  buttonContainer: {
    display: 'flex',
    gap: '20px',
  },
  dataGrid: {
    border: 0,
    color: '#1C2541',
    borderRadius: '8px',
    '& .MuiDataGrid-columnHeadersInner': {
      backgroundColor: '#F9F9FB',
      borderRadius: '8px',
      borderBottom: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #ECEEF1',
      borderTop: 'none',
    },
    '& .MuiDataGrid-cell': {
      borderBottom: 'none',
      borderTop: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: 'none',
      borderTop: 'none',
    },
    '&.MuiDataGrid-root .MuiDataGrid-cell, &.MuiDataGrid-root .MuiDataGrid-columnHeader': {
      '&:focus, &:focus-within': {
        outline: 'none',
      },
    },
  },
}));
